<form (submit)="submit()">
  
  <div class="container-large" [ngClass]="{'upload': form.value.rights === 'Upload', 'download': form.value.rights === 'Download'}">
    <div class="row">
      @if(form.value.rights === 'Upload') {
      <div class="col-md-10">
        <header class="screen-header upload fade-in">

          <div class="back">
            <a routerLink="/person-view" class="text-decoration-none">
              <i class="far fa-chevron-left"></i> {{ 'back' | translate }}
            </a>  
          </div>
          
          <div class="content">
            <span class="icon-image">
              <img src="/public/images/upload-icon-color.svg" />
            </span>
            <div class="button-text">
              <h1 class="m-0">{{'requestHeader' | translate }} <strong class="text-higlight text-gradient">{{'upload' | translate }}</strong> </h1>
              <span>{{ 'uploadToTeamsFolderSub'| translate}}</span>
            </div>
          </div>

        </header>
      </div>
      } @else if(form.value.rights === 'Download') {
      <div class="col-md-10">
        <header class="screen-header download fade-in">
          <div class="back">
            <a routerLink="/person-view" class="text-decoration-none">
              <i class="far fa-chevron-left"></i> {{ 'back' | translate }}
            </a>  
          </div>
          <div class="content">
            <span class="icon-image">
              <img src="/public/images/download-icon-color.svg" />
            </span>
            <div class="button-text">
              <h1 class="m-0">{{'downloadFromTeamsFolder' | translate }} <strong class="text-higlight text-gradient">{{'download' | translate }}</strong></h1>
              <span>{{ 'downloadFromTeamsFolderSub'| translate}}</span>
            </div>
          </div>
        </header>
      </div>
      }

      <div class="col-md-7 mb-3">
        <mat-card style="height:100%" class="fade-up">
          <mat-card-header>
            <span class="step-container">1</span> 
            <div>
              <mat-card-title>{{ 'sharePointBlock.title' | translate }}</mat-card-title>
              <mat-card-subtitle>{{ 'sharePointBlock.subText' | translate }}</mat-card-subtitle>
            </div>
          </mat-card-header>
          
          <mat-card-content style="position: relative;">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'sharePointBlock.site' | translate }}
                @if (loadingSites) {
                  <mat-spinner [diameter]="15" class="inline"></mat-spinner>
                }
              </mat-label>
              <mat-select [formControl]="form.controls.siteId">
                @for (site of sites; track site) {
                <mat-option [class.selected-site]="site.siteId === form.value.siteId" [value]="site.siteId">
                  {{site.displayName}}
                </mat-option>
                }
              </mat-select>
              @if (form.controls.siteId.errors?.['required']) {
              <mat-error>{{ 'error.site' | translate }}</mat-error>
              }
            </mat-form-field>

            @if (loadingSite) {
              <div class="spinner-wrapper">
                <mat-spinner></mat-spinner>
                <span class="spinner-label">{{ 'map-loading' | translate }}</span>
              </div>
            } @else {
            
            @if (form.value.siteId) {
            <app-folder-tree [siteId]="form.value.siteId"
              [folders]="folders"
              [selectedFolder]="selectedFolder"
              [loadingMore]="loadingMoreFolders"
              [hasMoreFolders]="hasMoreFolders"
              (folderEvent)="onFolderSelected($event)"
              (loadMoreRequested)="onLoadMoreFolders()"
              (createFolderRequested)="onCreateFolderRequested($event)"></app-folder-tree>
            }
            }
            @if (loading) {
              <div class="spinner-wrapper">
                <mat-spinner></mat-spinner>
                <span class="spinner-label">{{ 'map-loading' | translate }}</span>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-5 mb-3">
        <mat-card class="card-horizontal fade-up delay-1">
          <mat-card-header class="col-md-12">
            <span class="step-container">2</span> 
            <div>
            <mat-card-title>{{ 'personCreate.personBlock.title' | translate }}</mat-card-title>
            <mat-card-subtitle>{{ 'personCreate.personBlock.subText' | translate }}</mat-card-subtitle>
          </div>
          </mat-card-header>

          <mat-card-content class="col-md-12">
            @if (showError) {
            {{ 'error.person' | translate }}
            }
            <mat-form-field appearance="outline">
              <mat-label>{{ 'firstName' | translate }}</mat-label>
              <input matInput [formControl]="form.controls.firstName" [placeholder]="'firstName' | translate" />
              @if (form.controls.firstName.errors?.['required']) {
              <mat-error>{{ 'error.firstName' | translate }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'lastName' | translate }}</mat-label>
              <input matInput [formControl]="form.controls.lastName" [placeholder]="'lastName' | translate" />
              @if (form.controls.lastName.errors?.['required']) {
              <mat-error>{{ 'error.lastName' | translate }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'email' | translate }}</mat-label>
              <input matInput [formControl]="form.controls.email" [placeholder]="'email' | translate" />
              @if (form.controls.email.errors?.['required']) {
              <mat-error>{{ 'error.emailRequired' | translate }}</mat-error>
              }
              @if (form.controls.email.errors?.['pattern']) {
              <mat-error>{{ 'error.emailInvalid' | translate }}</mat-error>
              }
            </mat-form-field>
            <div class="row">
              <div class="col-md-6">

                <mat-form-field appearance="outline">
                  <mat-label>{{ 'language' | translate }}</mat-label>
                  <mat-select [formControl]="form.controls.language">
                    <mat-option value="Dutch">{{ 'dutch' | translate }}</mat-option>
                    <mat-option value="English">{{ 'english' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
              <div class="col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'personCreate.personBlock.tokenEndDate' | translate }}</mat-label>
                  <mat-select [formControl]="form.controls.endDateType">
                    <mat-option value="1">{{'daysDifference.oneDay'| translate }}</mat-option>
                    <mat-option value="7">{{'daysDifference.days'| translate:{count:7} }} ({{'default' |
                      translate}})</mat-option>
                    <mat-option value="14">{{'daysDifference.days'| translate:{count:14} }}</mat-option>
                    <mat-option value="30">{{'daysDifference.days'| translate:{count:30} }}</mat-option>
                    <mat-option value="90">{{'daysDifference.days'| translate:{count:90} }}</mat-option>
                    <mat-option value="180">{{'daysDifference.days'| translate:{count:180} }}</mat-option>
                    <mat-option value="custom">Custom</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

         

            
            @if (form.value.endDateType === 'custom') {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'personCreate.personBlock.tokenEndDate' | translate }}</mat-label>
              <input matInput [min]="minDate" [max]="maxDate" [formControl]="form.controls.endDate"
                [matDatepicker]="picker" [placeholder]="'personCreate.personBlock.tokenEndDate' | translate" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            }

            <strong class="d-block pb-1">{{ 'personCreate.messageBlock.title' | translate }}</strong>
         
            <mat-form-field appearance="outline">
              <mat-label>{{ 'personCreate.messageBlock.label' | translate }}</mat-label>
              <textarea matInput [formControl]="form.controls.message" [placeholder]="'personCreate.messageBlock.subText' | translate"></textarea>
            </mat-form-field>
            <!-- <div>
              <label><b>{{ 'personCreate.personBlock.rights' | translate }}</b></label>
              <mat-radio-group [formControl]="form.controls.rights">
                @for (item of PersonRightsTypes; track item) {
                <mat-radio-button [value]="item.value">{{ item.text }}</mat-radio-button>
                }
              </mat-radio-group>
              @if (form.controls.rights.errors?.['invalidRight']) {
              <mat-error>{{ 'error.rights' | translate }}</mat-error>
              }
            </div> -->
            <div style="display:flex;justify-content:space-between;gap:16px">
            &nbsp;
            <button mat-flat-button class="btn-lg" color="primary" type="submit" [disabled]="preventSubmit">
              <i class="fa-light fa-paper-plane-top"></i>&nbsp; {{ 'personDetails.sendInvitation' | translate }}
            </button>
          </div>
        
          </mat-card-content>
        </mat-card>
            <!--  
            <mat-card class="card-horizontal">
                <mat-card-header class="col-md-5">
                  <i class="fa-solid fa-check" matCardAvatar></i>
                  <mat-card-title>{{ 'personCreate.createBlock.title' | translate }}</mat-card-title>
                  <mat-card-subtitle>{{ 'personCreate.createBlock.subText' | translate }}</mat-card-subtitle>
                </mat-card-header>

                <mat-card-actions class="col-md-7">

                </mat-card-actions>
              </mat-card>
            -->
      </div>
    </div>
    <!--
    <div class="col-md-12 mt-1">
        <div style="display:flex;justify-content:space-between;gap:16px">
          <button mat-stroked-button color="basic" routerLink="/person-view" type="button">
            {{ 'cancel' | translate }}
          </button>

          <div style="display: flex;gap:16px">
           
          </div>
        </div>

      </div>-->
    </div>


</form>